import {httpGet} from "./api/axios_api";
import Constants from "../constants/constants";

export const actions = {
    getSplitIOTreatments: "GET_SPLITIO_TREATMENTS"
}

export function getSplitIOTreatments(featureName, trafficType, token){
    return dispatch => {
        const url = encodeURI(`${Constants.BACKEND_URL}/splitio/${trafficType}/${featureName}`);
        return httpGet(url,{}, token).then((response)=>{
            if(typeof response !== "undefined"){
                if(response.data.success){       
                    dispatch({
                        type: actions.getSplitIOTreatments,
                        treatment: response.data.treatment
                    }); 
                }
            }
        });
    }
}

const INITIAL_STATE = {
    treatments: {}
}

export default function reducer(state = INITIAL_STATE, action){
    switch (action.type){
        case actions.getSplitIOTreatments:
            return {
                ...state,
                treatments: {...state.treatments, ...action.treatment}
            }
        default:
            return {...state};
    }
}


// WEBPACK FOOTER //
// ./src/modules/splitIO.js